













import { Component, Prop, Vue } from 'vue-property-decorator';
import BillingService from '@/api/BillingService';

import FilledButton from '../FilledButton/FilledButton.vue';
import { EBusinessUserType } from '@/store/modules/businessTypes';
import eventBus from '@/utils/eventBus';
import { ModalOptionsV2 } from '@/components/Modal/ModalOptions';
import { getBillingIsHidden, getBillingIsPending } from '@/utils/billing';

@Component({
  components: {
    FilledButton
  }
})
export default class BannerActivateBilling extends Vue {
  @Prop() welcomeCtaText!: string;
  @Prop() description?: string;

  loading = false;

  service: BillingService = new BillingService();

  get business() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get billingStatus() {
    return this.business.subscriptionStatus;
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  // The banner's only action is opening a billing modal, so there is nothing to
  // keep once billing is hidden. Guarded here rather than at each render site
  // because the Performance screens compute their own `showActivateBillingBanner`
  // straight off `billingStatus`, bypassing BillingModel (TWISM-19008).
  get billingIsHidden() {
    return getBillingIsHidden();
  }

  get text() {
    return (
      this.description ||
      'Upgrade your Twism Program to the Coin Network to have access to this feature.'
    );
  }

  async onActivateBilling(loading: boolean = true) {
    if (
      this.$store.getters['business/getManagerRole'] !== EBusinessUserType.OWNER
    ) {
      this.$notification(
        "You don't have permission to upgrade your account",
        'error'
      );
      return;
    }
    const modal = getBillingIsPending() ? 'Acceptance' : 'Reactivation';
    try {
      this.loading = loading;
      if (!loading) this.$showLoader();

      const {
        overview,
        features
      } = await this.service.getOverviewAndActivedFeatures(
        modal !== 'Reactivation'
      );

      eventBus.$emit(
        'openSubModal',
        new ModalOptionsV2({
          componentToRender: `coinNetwork${modal}Modal`,
          hideCancelButton: false,
          icon: '',
          mobileFullScreen: true
        }),
        {
          welcomeCtaText: this.welcomeCtaText,
          subscription: overview,
          features,
          origin: 'Upgrade Banner'
        }
      );
    } finally {
      if (!loading) this.$hideLoader();

      this.loading = false;
    }
  }

  created() {
    eventBus.$on('upgradeBillingBanner', this.onActivateBilling);
  }

  beforeDestroy() {
    eventBus.$off('upgradeBillingBanner', this.onActivateBilling);
  }
}
